module.exports = __webpack_public_path__ + "img/internet5.8c2296fb.png";